/**=========================================================
 * Module: login.js
 * Login Controller
 =========================================================*/

App.controller('RecoverController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R) {
    "use strict";
    
    $scope.username="";
    $scope.submitting = false;
    $scope.sent = false;
      
    $scope.reset = function(){
    
        if($scope.username){
            $scope.submitting = true;
            R.one('action','ResetPassword').customPUT({ username: $scope.username }).then(
                function(){
                    $scope.submitting = false;
                    $scope.sent = true;
                },
                function(){
                    $scope.submitting = false;
                }
            );
        }
    }
  }
]);
